import React, { useState } from "react";
import "./textInputStyle.scss";

const TextInput = ({ 
  label, 
  type = "text", 
  name, 
  value, 
  onChange, 
  placeholder, 
  required = false,
  disabled,
  requiredMsg = '',
  isAutoPopulated = false
}) => {
  const [isTouched, setIsTouched] = useState(false);

  return (
    <div className="form-group text-input">
      <label htmlFor={name} className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
      <input
        type={type}
        className={`form-control ${isAutoPopulated ? 'custom-bg' : ''}`}
        id={name}
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e);
          setIsTouched(true);
        }}
        onBlur={() => setIsTouched(true)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
      />
      {required && isTouched && !value && (
        <small className="error-text">{requiredMsg ? requiredMsg : "This field is required"}</small>
      )}
    </div>
  );
};

export default TextInput;